module.exports = __webpack_public_path__ + "static/media/vehicle-lock.ca2f58e6.mp4";